import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <Link to={"/"} className="pb-1 border-b-2 border-congressBlue">
        <p>You seem lost? Go to Home</p>
      </Link>
    </div>
  );
};

export default NotFound;
